<template>
  <div class="container" style="height: 100%">
    <FullScreenLoader v-if="loading" />
    <div style="height: 100%" v-else>
      <div class="center-screen" v-if="errorMessage" style="height: 100vh; margin-top: 40px">
        <div class="alert alert-danger" style="width: 100%">
          <h3>{{ errorMessage }}</h3>
        </div>
      </div>
      <div v-else>
        <RecoveryCertificateComponent :data="validationResult" :shaIsZero="shaIsZero" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import RecoveryCertificateComponent from './components/recovery-certificate-component.vue';
import FullScreenLoader from '@/components/fullscreen-loader.vue';

export default {
  components: {
    RecoveryCertificateComponent,
    FullScreenLoader,
  },
  data() {
    return {
      loading: true,
      errorMessage: null,
      validationResult: null,
      shaIsZero: false,
    };
  },
  created() {
    this.validate();
  },
  methods: {
    async validate() {
      this.errorMessage = null;
      const url_string = window.location.href;
      const url = new URL(url_string);
      const id = url.searchParams.get('id');
      const sha = url.searchParams.get('sha');

      if (!id || !sha) {
        this.loading = false;
        this.errorMessage = 'Invalid URL';
        return;
      }

      if (sha == 0) this.shaIsZero = true;

      const payload = {
        id: id,
        sha: sha,
      };
      await axios
        .post(`${this.$baseUrlApi}/healthcheck-restful-api/recovery/verification/validate`, payload)
        .then((res) => {
          if (res.status == 200) this.validationResult = res.data;
          else this.validationResult = null;
        })
        .catch((error) => {
          this.validationResult = null;
          console.error(error);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>